import React from "react";
import { gql } from "@apollo/client";
import { Link } from "react-router-dom";

import {
  styled,
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from "@mui/material";
import { Email as EmailIcon, Pencil as EditIcon } from "mdi-material-ui";

const LoginIcon = styled(Box)`
  font-size: inherit !important;
  width: 1em;
  height: 1em;
  margin-right: 0.5ch;
  margin-bottom: -2px;
`;

export default function OrderSidebarHeader({ order }) {
  return (
    <ListItem dense>
      <ListItemAvatar>
        <Avatar src={order.user.profile.picture} alt="" />
      </ListItemAvatar>

      <ListItemText
        primary={order.user.profile.fullName}
        secondary={
          <>
            {order.user.loginType !== "EMAIL" && (
              <LoginIcon component={EmailIcon} style={{ marginBottom: -3 }} />
            )}
            {order.user.loginType === "GOOGLE" && (
              <LoginIcon component="img" src={require("./images/google.svg")} />
            )}
            {order.user.loginType === "FACEBOOK" && (
              <LoginIcon
                component="img"
                src={require("./images/facebook.svg")}
              />
            )}
            {order.user.profile.email}
          </>
        }
        primaryTypographyProps={{ noWrap: true }}
        secondaryTypographyProps={{ noWrap: true }}
      />
      <ListItemSecondaryAction>
        <IconButton
          size="small"
          component={Link}
          to={`/admin/users/${order.user.id}`}
        >
          <EditIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
}

OrderSidebarHeader.fragments = {
  order: gql`
    fragment Orders_OrderSidebarHeader_Order on Order {
      id

      user {
        id
        loginType
        profile {
          email
          fullName
          picture
        }
      }
    }
  `,
};
